module.exports = __webpack_public_path__ + "static/media/Inter-roman.var.57fa490c.woff2";